import { render, staticRenderFns } from "./ButtonsActionsThux.vue?vue&type=template&id=643e9364&"
import script from "./ButtonsActionsThux.vue?vue&type=script&lang=js&"
export * from "./ButtonsActionsThux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports